export default '/static/frontend/ReachDigital/12gobiking/dist/assets/paypal-ef015279.svg'